module.exports = __webpack_public_path__ + "static/media/perfil.cb3eb0f0.svg";